import React from 'react';
import BarComponent from './BarComponent';
import ChartLoading from './ChartLoading';
import { BAR_CHART, PIE_CHART, useChartData } from './config';
import PieComponent from './PieComponent';
import { useViolationBar } from '../data';

const Violation = ({ loading, violation }) => {
  const { violationBar } = useViolationBar();

  const pieData = useChartData({ data: violation, type: PIE_CHART, label: 'Jumlah Pelanggaran' });
  const barData = useChartData({ data: violationBar, type: BAR_CHART, label: 'Jumlah Pelanggaran' });

  return (
    <>
      {loading ? <ChartLoading /> : <PieComponent data={pieData} />}
      {/* <hr />
      Pelanggaran Tertinggi Perusahaan
      <BarComponent data={barData} /> */}
    </>
  );
}

export default Violation;